import { Box, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import useColors from "api/hooks/useColors";

const IntegrationsByCustomerWidget = ({ customers, isLoading }) => {
  const colors = useColors();

  const chartData = customers
    ? customers
        .filter((c) => c.integrations_count > 0)
        .sort((a, b) => b.integrations_count - a.integrations_count)
    : [];

  const xAxisData = chartData.map((c) => c.customer_id);
  const seriesData = chartData.map((c) => c.integrations_count);

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  if (!chartData || chartData.length === 0) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Typography color="text.secondary">No data available</Typography>
      </Box>
    );
  }

  const chartWidth = Math.max(chartData.length * 60, 600);

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        overflowX: "auto",
        overflowY: "hidden",
        padding: "16px 0",
        "&::-webkit-scrollbar": {
          height: "8px",
        },
        "&::-webkit-scrollbar-track": {
          background: colors.grey_100,
          borderRadius: "4px",
        },
        "&::-webkit-scrollbar-thumb": {
          background: colors.grey_300,
          borderRadius: "4px",
          "&:hover": {
            background: colors.grey_400,
          },
        },
      }}
    >
      <Box sx={{ width: chartWidth, height: "100%", minHeight: "300px" }}>
        <BarChart
          xAxis={[
            {
              scaleType: "band",
              data: xAxisData,
              tickLabelStyle: {
                angle: -45,
                textAnchor: "end",
                fontSize: 10,
              },
            },
          ]}
          series={[
            {
              data: seriesData,
              label: "Integrations",
              color: colors.primary_main,
            },
          ]}
          height={300}
          margin={{ bottom: 80, left: 60, right: 20, top: 20 }}
        />
      </Box>
    </Box>
  );
};

export default IntegrationsByCustomerWidget;
